module.exports = __webpack_public_path__ + "static/img/template_img_01.94759b11.jpg";